import { createRoot } from 'react-dom/client'
import { CartDrawerTest } from './CartDrawerTest'

const ISLAND_SELECTOR = '[data-nova-react-island="cart-drawer"], #nova-react-cart-drawer'

function getCartDrawerConfig(root) {
  return {
    ...(window.novaThemeReact?.cartDrawer || {}),
    ...root.dataset,
  }
}

function mountCartDrawerIsland(root) {
  if (root.__novaReactRoot) {
    return
  }

  root.__novaReactRoot = createRoot(root)
  root.__novaReactRoot.render(<CartDrawerTest config={getCartDrawerConfig(root)} />)
}

document.querySelectorAll(ISLAND_SELECTOR).forEach(mountCartDrawerIsland)
